import React from "react";
import map from "lodash/map";
import "./languageSwitcher.scss";
import { v4 as uuidv4 } from "uuid";

const LanguageSwitcher = ({
  handleSetActiveTab,
  activeTab,
  typeArr,
  disableTypes,
  isFetchingIaC
}) => {
  const typeTitles = {
    typescript: "TypeScript",
    python: "Python",
    go: "Go",
    csharp: "C#",
    java: "Java",
  };
  const renderTypes = () => {
    return map(typeArr, (type) => {
      let disabled = (disableTypes && type !== "naive") || (isFetchingIaC && activeTab !== type);
      return (
        <div
          key={uuidv4()}
          onClick={() => {
            if (disabled) {
              return null;
            }
            handleSetActiveTab(type);
          }}
          className={`LanguageSwitcher-item center ${
            activeTab === type && "active"
          } ${disabled && "disabled"}`}
        >
          {typeTitles[type]}
        </div>
      );
    });
  };
  return <div className="LanguageSwitcher row">{renderTypes()}</div>;
};

export default LanguageSwitcher;
